const rotas: Array<any> = [
  {
    denied: ['PLANO_CALCULADORA'],
    icone: 'home',
    texto: 'Home',
    url: '/dashboard',
    viewName: 'dashboard',
    keyAuthorized: 'dashboard',
    isAuthorized: false,
  },
  {
    denied: ['PLANO_CALCULADORA'],
    icone: 'add_box',
    texto: 'Produção',
    url: '/producao',
    viewName: 'producao',
    keyAuthorized: 'producao',
    isAuthorized: false,
  },
  {
    denied: ['PLANO_CALCULADORA'],
    icone: 'assignment',
    texto: 'Recebimento',
    url: '/recebimento',
    viewName: 'recebimento',
    keyAuthorized: 'recebimento',
    isAuthorized: false,
  },
  {
    icone: 'receipt',
    texto: 'Agendamento',
    url: '/agendamento-medico',
    viewName: 'agendamento-medico',
    keyAuthorized: 'agendamento-medico',
    isAuthorized: false,
  },
  {
    hideOnMobile: true,
    denied: ['PLANO_CALCULADORA'],
    icone: 'assessment',
    texto: 'Relatório',
    url: '/relatorio/fonte-pagadora',
    viewName: 'relatorio',
    keyAuthorized: 'relatorio',
    isAuthorized: false,
  },
  {
    hideOnMobile: true,
    icone: 'work',
    texto: 'Backoffice',
    url: '/backoffice/agendamento',
    viewName: 'backoffice-agendamento',
    keyAuthorized: 'backoffice-agendamento',
    isAuthorized: false,
  },
  {
    hideOnMobile: true,
    icone: 'smartphone',
    texto: 'Calculadora',
    url: '/calculadora',
    viewName: 'calculadora',
    keyAuthorized: 'calculadora',
    isAuthorized: false,
  },
  {
    hideOnMobile: true,
    icone: 'help',
    texto: 'Ajuda',
    url: '/ajuda',
    viewName: 'ajuda',
    keyAuthorized: 'perfil',
    isAuthorized: true,
  },
  {
    hideOnMobile: true,
    icone: 'account_box',
    texto: 'Perfil',
    url: '/perfil',
    viewName: 'perfil',
    keyAuthorized: 'perfil',
    isAuthorized: true,
  },
]

export default rotas
